import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  CubeIcon,
  ShoppingBagIcon,
  UserIcon,
  ChartBarIcon,
  Cog6ToothIcon,
  ShoppingCartIcon,
  QrCodeIcon,
} from '@heroicons/react/24/outline';

const VendorLayout = ({ children }) => {
  const location = useLocation();

  const navigation = [
    {
      name: 'لوحة التحكم',
      href: '/vendor/dashboard',
      icon: HomeIcon,
    },
    {
      name: 'المنتجات',
      href: '/vendor/products',
      icon: CubeIcon,
    },
    {
      name: 'الطلبات',
      href: '/vendor/orders',
      icon: ShoppingBagIcon,
    },
    {
      name: 'نقطة البيع',
      href: '/vendor/pos',
      icon: ShoppingCartIcon,
    },
    {
      name: 'التقارير',
      href: '/vendor/reports',
      icon: ChartBarIcon,
    },
    {
      name: 'بطاقة المتجر',
      href: '/vendor/store-card',
      icon: QrCodeIcon,
    },
    {
      name: 'الملف الشخصي',
      href: '/vendor/profile',
      icon: UserIcon,
    },
    {
      name: 'الإعدادات',
      href: '/vendor/settings',
      icon: Cog6ToothIcon,
    },
  ];

  const isActive = (href) => {
    return location.pathname === href || location.pathname.startsWith(href + '/');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="flex">
        {/* Sidebar */}
        <div className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0">
          <div className="flex-1 flex flex-col min-h-0 bg-white shadow-lg">
            <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
              <div className="flex items-center flex-shrink-0 px-4 mb-8">
                <img 
                  src="/logo-small.png" 
                  alt="أمازول" 
                  className="h-10 w-auto ml-2"
                />
                <h2 className="text-xl font-bold text-gray-900">لوحة البائع</h2>
              </div>
              <nav className="mt-5 flex-1 px-2 space-y-1">
                {navigation.map((item) => {
                  const Icon = item.icon;
                  return (
                    <Link
                      key={item.name}
                      to={item.href}
                      className={`group flex items-center px-2 py-2 text-sm font-medium rounded-md transition-colors ${
                        isActive(item.href)
                          ? 'bg-primary-100 text-primary-900'
                          : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                      }`}
                    >
                      <Icon
                        className={`ml-3 flex-shrink-0 h-6 w-6 ${
                          isActive(item.href)
                            ? 'text-primary-500'
                            : 'text-gray-400 group-hover:text-gray-500'
                        }`}
                      />
                      {item.name}
                    </Link>
                  );
                })}
              </nav>
            </div>
          </div>
        </div>

        {/* Main content */}
        <div className="md:pr-64 flex flex-col flex-1">
          <main className="flex-1">
            <div className="py-6">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                {children}
              </div>
            </div>
          </main>
        </div>
      </div>

      {/* Mobile menu */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-2">
        <div className="flex justify-around">
          {navigation.slice(0, 4).map((item) => {
            const Icon = item.icon;
            return (
              <Link
                key={item.name}
                to={item.href}
                className={`flex flex-col items-center py-2 px-3 rounded-lg ${
                  isActive(item.href)
                    ? 'text-primary-600'
                    : 'text-gray-500'
                }`}
              >
                <Icon className="h-6 w-6" />
                <span className="text-xs mt-1">{item.name}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default VendorLayout;